// extracted by mini-css-extract-plugin
module.exports = {"layout":"page_80mm_48mm_1_label_per_page_layout__157nK"};